((TileReviews, $) => {
  'use strict';

  let $productTilesMeta;

  const build = (data, $this) => {
    const totalReviews = data.response.reviews.length;
    let totalScore = 0;
    for (let i = 0; i < totalReviews; i++) {
      totalScore += data.response.reviews[i].score;
    }
    let realTotal = 0;
    let iterator;

    if (totalReviews !== 0) {
      realTotal = totalScore / totalReviews.toFixed();
    }

    let html = '';
    html += '<div class="ratings">';
    if (totalReviews !== 0) {
      html +=   '<span class="star-wrap">';
      iterator = 0;
      while(iterator < 5) {
        if (realTotal >= 1) {
          html += '<span class="fa fa-star"></span>';
        } else if (realTotal <= 0) {
          html += '<span class="fa fa-star-o"></span>';
        } else {
          html += '<span class="fa fa-star fa-star-half-o"></span>';
        }
        realTotal -= 1;
        iterator += 1;
      }
      html +=   '</span>';
    }
    html +=   '<span class="count-reviews">';
    if (totalReviews === 0) {
      html += '(0 Reviews)';
    } else if (totalReviews === 1) {
      html += '(1)'
    } else {
      html += '(' + totalReviews + ')';
    }
    html +=   '</span>';
    html += '</div>';

    $this.prepend(html);
  };

  const cacheDom = () => {
    $productTilesMeta = $('.grid-meta');
  };

  const run = (url, $elements) => {
    $elements.each(function(){
      const productId = $(this).data('product-id');
      const appUrl = `//yotpo-seed-all.herokuapp.com/yotpo-fetch?shop=${url}&pid=${productId}`;
      const that = this;

      $.ajax({
        url: appUrl,
        dataType: 'json',
        method: 'GET',

        success: function(data) {
          build(data, $(that));
        },

        error: function(err) {
          throw err;
        }
      });
    });
  };

  const init = (url) => {
    cacheDom();
    console.log($productTilesMeta)
    run(url, $productTilesMeta);
  };

  TileReviews.init = init;
  TileReviews.run = run;
})(window.TileReviews = window.TileReviews || {}, jQuery);
